if (!customElements.get('gift-product-options')) {
  customElements.define(
    'gift-product-options',
    class GiftProductOptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.form = document.getElementById(this.dataset.productFormId);
        this.messageCardSelect = this.querySelector('[data-gift-message-card]');
        this.messageContentField = this.querySelector('[data-gift-message-content]');
        this.messageContentInput = this.querySelector('[data-gift-message-content-input]');

        if (!this.form || !this.messageCardSelect) return;

        this.initialized = true;
        this.messageCardSelect.addEventListener('change', this.handleMessageCardChange);
        this.form.addEventListener('formdata', this.handleFormData);
        this.updateMessageContent();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.messageCardSelect.removeEventListener('change', this.handleMessageCardChange);
        this.form.removeEventListener('formdata', this.handleFormData);
        this.initialized = false;
      }

      handleMessageCardChange = () => {
        this.updateMessageContent();
      };

      handleFormData = (event) => {
        [this.messageContentInput].forEach((input) => {
          if (!input?.name) return;

          const value = input.value.trim();
          if (input.disabled || value === '') {
            event.formData.delete(input.name);
          } else {
            event.formData.set(input.name, value);
          }
        });
      };

      updateMessageContent() {
        const visible = this.messageCardSelect.value === '自由メッセージ';
        this.toggleConditionalField(this.messageContentField, this.messageContentInput, visible);
      }

      toggleConditionalField(field, input, visible) {
        if (!field || !input) return;

        field.hidden = !visible;
        input.disabled = !visible;
        if (!visible) input.value = '';
      }
    }
  );
}
